<template>
  <div id="app">
    <router-view/>
    <router-view name="footer"></router-view>
  </div>
  
</template>

<script>
import Vue from 'vue';

export default {
  name: 'App',
  mounted(){





  }

}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
</style>



// WEBPACK FOOTER //
// src/App.vue